import React, { useState, useContext, useEffect } from 'react';
import getSuitCSSClasses from '@/utils/getSuitCSSClasses';
import { useI18nContext } from '@ecg-marktplaats/js-react-i18n';
import { RowHeader, TextField } from '@hz-design-system/web-ui';
import experiments from '@/utils/labs/experiments';
import EnvironmentContext from '@/client/contexts/EnvironmentContext';
import { linkGeneratorHelper, generateLinkObject } from '@/utils/links/linkGeneratorHelper';
import removeSavedSearchFlag from '@/client/utils/searchRequestUtils';
import useIsMarktplaats from '@/client/hooks/useIsMarktplaats';
import getClientPageQueryObject from '@/client/utils/getClientPageQueryObject';
import pushToRouter from '@/client/utils/pushToRouter';
import CATEGORIES_L1 from '@/constants/categories.ts';

type TTextFacetProps = {
  inputKey: string;
  searchRequestObject: TSearchRequestObject;
};

const QueryFilter = ({ inputKey, searchRequestObject }: TTextFacetProps) => {
  const { t } = useI18nContext();
  const { labsConfig } = useContext(EnvironmentContext);
  const { isFetchResultsOnceAllCatEnabled, isFetchResultsOnceEnabled, isFetchResultsHIOnceEnabled } = experiments({
    labsConfig,
  });

  const isMarktplaats = useIsMarktplaats();
  const [value, setValue] = useState(searchRequestObject.searchQuery);
  const withAllAttributes =
    isFetchResultsOnceAllCatEnabled ||
    (isFetchResultsOnceEnabled && searchRequestObject.categories?.l1Category?.id === CATEGORIES_L1.DAMES_KLEREN) ||
    (isFetchResultsHIOnceEnabled &&
      isMarktplaats &&
      searchRequestObject.categories?.l1Category?.id === CATEGORIES_L1.HUIS_EN_INRICHTING);

  useEffect(() => {
    setValue(searchRequestObject.searchQuery);
  }, [searchRequestObject.searchQuery]);

  const searchWithVariant = () => {
    window.preventScroll = true;
    const options = {
      searchRequestObject: removeSavedSearchFlag(searchRequestObject),
      withAllAttributes,
      query: value,
    };
    const href = linkGeneratorHelper(options);
    const pageQuery = getClientPageQueryObject(generateLinkObject(options));
    pushToRouter({ query: pageQuery, href });
  };

  const handleOnKeyPress = (event) => {
    if (event.key === 'Enter') {
      searchWithVariant();
    }
  };

  return (
    <div className={getSuitCSSClasses({ namespace: 'hz', name: 'Filter' })}>
      <RowHeader title={t(`facets.${inputKey}`)} />
      <div className={getSuitCSSClasses({ namespace: 'hz', name: 'Filter-text' })}>
        <TextField
          type="text"
          placeholder={t(`facets.${inputKey}Placeholder`)}
          onChange={(e) => setValue(e.target.value)}
          onBlur={searchWithVariant}
          onKeyPress={handleOnKeyPress}
          value={value}
          ariaLabel={t(`facets.${inputKey}`)}
        />
      </div>
    </div>
  );
};

export default QueryFilter;
